<template>
    <div>
        <div style="margin-bottom: 5px;">
            <el-input v-model="keyword" placeholder="请输入商品名" suffix-icon="el-icon-search" style="width: 180px;"
                      @keyup.enter.native="loadPost"></el-input>
            <el-select v-model="categoryFilter" filterable placeholder="分类筛选" style="margin-left: 5px; width: 140px;">
                <el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-button type="primary" style="margin-left: 5px;" @click="loadPost">查询</el-button>
            <el-button type="success" @click="resetParam">重置</el-button>
            <el-button type="primary" style="margin-left: 5px;" @click="add">新增商品</el-button>
        </div>
        <el-table :data="tableData"
                  :header-cell-style="{ background: '#f2f5fc', color: '#555555' }"
                  border>
            <el-table-column prop="id" label="ID" width="50"></el-table-column>
            <el-table-column label="图片" width="80">
                <template slot-scope="scope">
                    <el-image :src="imgUrl(scope.row.image)" fit="cover" style="width: 46px; height: 46px; border-radius: 4px;"
                              :preview-src-list="[imgUrl(scope.row.image)]" preview-teleported>
                        <div slot="error" style="width: 46px; height: 46px; display: flex; align-items: center; justify-content: center; color: #ccc; font-size: 12px;">无图</div>
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="商品名" width="160"></el-table-column>
            <el-table-column prop="category" label="分类" width="90"></el-table-column>
            <el-table-column label="原价" width="90">
                <template slot-scope="scope">￥{{ Number(scope.row.price).toFixed(2) }}</template>
            </el-table-column>
            <el-table-column label="折扣" width="90">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.discount && scope.row.discount > 0 && scope.row.discount < 10"
                            type="danger" disable-transitions>{{scope.row.discount}} 折</el-tag>
                    <span v-else style="color: #999;">不打折</span>
                </template>
            </el-table-column>
            <el-table-column label="折后价" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.discount && scope.row.discount > 0 && scope.row.discount < 10"
                          style="color: #e0539c; font-weight: 600;">
                        ￥{{ (Number(scope.row.price) * scope.row.discount / 10).toFixed(2) }}</span>
                    <span v-else>—</span>
                </template>
            </el-table-column>
            <el-table-column prop="description" label="描述" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="标签" width="150">
                <template slot-scope="scope">
                    <el-tag v-for="(t, i) in tagList(scope.row)" :key="i" size="mini"
                            style="margin-right: 4px; margin-bottom: 2px;" type="warning" disable-transitions>{{t}}</el-tag>
                    <span v-if="tagList(scope.row).length === 0" style="color: #999;">无</span>
                </template>
            </el-table-column>
            <el-table-column label="展示" width="80">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.isShow" active-value="Y" inactive-value="N"
                               @change="showChange(scope.row)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="operate" label="操作" width="230">
                <template slot-scope="scope">
                    <el-button size="small" type="warning" @click="setDiscount(scope.row)">设折扣</el-button>
                    <el-button size="small" type="success" @click="mod(scope.row)">编辑</el-button>
                    <el-popconfirm title="确定删除吗？" @confirm="del(scope.row.id)" style="margin-left: 5px;">
                        <el-button slot="reference" size="small" type="danger">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[5, 10, 20, 30]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
        </el-pagination>

        <!-- 新增/编辑商品 -->
        <el-dialog :title="form.id ? '编辑商品' : '新增商品'" :visible.sync="centerDialogVisible" width="40%" center>
            <el-form ref="form" :rules="rules" :model="form" label-width="80px">
                <el-form-item label="商品名" prop="name">
                    <el-col :span="20"><el-input v-model="form.name"></el-input></el-col>
                </el-form-item>
                <el-form-item label="分类" prop="category">
                    <el-col :span="20">
                        <el-select v-model="form.category" filterable allow-create placeholder="请选择或输入分类" style="width: 100%;">
                            <el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-col>
                </el-form-item>
                <el-form-item label="价格" prop="price">
                    <el-col :span="20"><el-input v-model="form.price" placeholder="单位：星裙币"></el-input></el-col>
                </el-form-item>
                <el-form-item label="图片">
                    <el-col :span="20">
                        <el-input v-model="form.image" placeholder="图片文件名，如 p1.jpg（放在 Storyshop/shop 目录）"></el-input>
                        <div style="margin-top: 6px;">
                            <el-image v-if="form.image" :src="imgUrl(form.image)" fit="cover"
                                      style="width: 60px; height: 60px; border-radius: 4px;"
                                      :preview-src-list="[imgUrl(form.image)]" preview-teleported>
                                <div slot="error" style="width: 60px; height: 60px; display: flex; align-items: center; justify-content: center; color: #ccc; font-size: 12px;">无图</div>
                            </el-image>
                        </div>
                    </el-col>
                </el-form-item>
                <el-form-item label="描述">
                    <el-col :span="20"><el-input v-model="form.description" type="textarea" :rows="2"></el-input></el-col>
                </el-form-item>
                <el-form-item label="折扣">
                    <el-col :span="20">
                        <el-select v-model="form.discount" placeholder="选择折扣" style="width: 100%;">
                            <el-option label="不打折" :value="null"></el-option>
                            <el-option v-for="d in [1,2,3,4,5,6,7,8,9]" :key="d" :label="d + ' 折'" :value="d"></el-option>
                        </el-select>
                    </el-col>
                </el-form-item>
                <el-form-item label="标签">
                    <el-col :span="20">
                        <el-select v-model="form.tagArr" multiple filterable allow-create default-first-option
                                   placeholder="最多4个标签，可直接输入" style="width: 100%;">
                            <el-option v-for="t in tagOptions" :key="t" :label="t" :value="t"></el-option>
                        </el-select>
                        <div style="color: #999; font-size: 12px; line-height: 1.6; margin-top: 4px;">添加 0-4 个，展示在前台商品卡片下方</div>
                    </el-col>
                </el-form-item>
                <el-form-item label="首页展示">
                    <el-col :span="20">
                        <el-switch v-model="form.isShow" active-value="Y" inactive-value="N"></el-switch>
                        <span style="margin-left: 8px; color: #999; font-size: 12px;">开启后商品展示在前台「物语小店展示」板块</span>
                    </el-col>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 设置折扣 -->
        <el-dialog title="设置商品折扣" :visible.sync="discountDialogVisible" width="30%" center>
            <div style="text-align: center; margin-bottom: 10px; color: #666;">
                <span>商品：{{discountForm.name}}</span>
            </div>
            <el-form label-width="80px">
                <el-form-item label="原价">
                    <span>￥{{ Number(discountForm.price).toFixed(2) }}</span>
                </el-form-item>
                <el-form-item label="折扣">
                    <el-select v-model="discountForm.discount" placeholder="选择折扣" style="width: 100%;">
                        <el-option label="不打折" :value="null"></el-option>
                        <el-option v-for="d in [1,2,3,4,5,6,7,8,9]" :key="d" :label="d + ' 折'" :value="d"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="折后价" v-if="discountForm.discount && discountForm.discount > 0 && discountForm.discount < 10">
                    <span style="color: #e0539c; font-weight: 600;">
                        ￥{{ (Number(discountForm.price) * discountForm.discount / 10).toFixed(2) }}</span>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="discountDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveDiscount">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    // 商品图片统一从 src/components/Storyshop/shop 目录打包加载
    const shopImages = require.context('../Storyshop/shop', false, /\.(jpg|jpeg|png|gif)$/)

    export default {
        name: "ShopManage",
        data() {
            return {
                user: JSON.parse(sessionStorage.getItem('CurUser') || '{}'),
                tableData: [],
                categoryOptions: [{value: '', label: '全部'}],
                keyword: '',
                categoryFilter: '',
                pageNum: 1,
                pageSize: 10,
                total: 0,
                centerDialogVisible: false,
                discountDialogVisible: false,
                form: {
                    id: '',
                    name: '',
                    category: '',
                    price: '',
                    image: '',
                    description: '',
                    discount: null,
                    tagArr: [],
                    isShow: 'Y'
                },
                tagOptions: [],
                discountForm: {
                    id: '',
                    name: '',
                    price: 0,
                    discount: null
                },
                rules: {
                    name: [{required: true, message: '请输入商品名', trigger: 'blur'}],
                    category: [{required: true, message: '请选择分类', trigger: 'change'}],
                    price: [
                        {required: true, message: '请输入价格', trigger: 'blur'},
                        {pattern: /^([1-9]\d*|0)(\.\d{1,2})?$/, message: '价格格式不正确', trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            imgUrl(file) {
                if (!file) return ''
                try {
                    return shopImages('./' + file)
                } catch (e) {
                    return ''
                }
            },
            loadCategory() {
                this.$axios.get(this.$httpUrl + '/shop/category/list').then(res => res.data).then(res => {
                    if (res.code == 200) {
                        let list = [{value: '', label: '全部'}]
                        res.data.forEach(c => list.push({value: c.name, label: c.name}))
                        this.categoryOptions = list
                    }
                })
            },
            resetForm() {
                this.$refs.form && this.$refs.form.resetFields();
            },
            tagList(row) {
                if (!row.tags) return []
                return row.tags.split(/[,，]/).map(s => s.trim()).filter(Boolean)
            },
            loadTagOptions() {
                let set = new Set(this.tagOptions)
                this.tableData.forEach(r => {
                    this.tagList(r).forEach(t => set.add(t))
                })
                this.tagOptions = Array.from(set)
            },
            showChange(row) {
                this.$axios.post(this.$httpUrl + '/shop/admin/show', {
                    id: row.id,
                    isShow: row.isShow,
                    operatorNo: this.user.no,
                    operatorName: this.user.name,
                    operatorRole: this.user.roleId
                }).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.$message({message: row.isShow === 'Y' ? '已设为首页展示' : '已取消首页展示', type: 'success'});
                        this.loadPost()
                    } else {
                        this.$message({message: res.msg || '操作失败！', type: 'error'});
                        this.loadPost()
                    }
                })
            },
            del(id) {
                this.$axios.get(this.$httpUrl + '/shop/admin/del', {
                    params: {
                        id: id,
                        operatorNo: this.user.no,
                        operatorName: this.user.name,
                        operatorRole: this.user.roleId
                    }
                }).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.$message({message: '操作成功！', type: 'success'});
                        this.loadPost()
                    } else {
                        this.$message({message: res.msg || '操作失败！', type: 'error'});
                    }
                })
            },
            add() {
                this.centerDialogVisible = true
                this.$nextTick(() => {
                    this.resetForm()
                    this.form = {id: '', name: '', category: '', price: '', image: '', description: '', discount: null, tagArr: [], isShow: 'Y'}
                })
            },
            mod(row) {
                this.centerDialogVisible = true
                this.$nextTick(() => {
                    this.form.id = row.id
                    this.form.name = row.name
                    this.form.category = row.category
                    this.form.price = row.price + ''
                    this.form.image = row.image || ''
                    this.form.description = row.description || ''
                    this.form.discount = row.discount || null
                    this.form.tagArr = this.tagList(row)
                    this.form.isShow = row.isShow || 'Y'
                })
            },
            setDiscount(row) {
                this.discountForm = {
                    id: row.id,
                    name: row.name,
                    price: Number(row.price),
                    discount: row.discount || null
                }
                this.discountDialogVisible = true
            },
            saveDiscount() {
                this.$axios.post(this.$httpUrl + '/shop/admin/discount', {
                    id: this.discountForm.id,
                    discount: this.discountForm.discount,
                    operatorNo: this.user.no,
                    operatorName: this.user.name,
                    operatorRole: this.user.roleId
                }).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.$message({message: '设置折扣成功！', type: 'success'});
                        this.discountDialogVisible = false
                        this.loadPost()
                    } else {
                        this.$message({message: res.msg || '操作失败！', type: 'error'});
                    }
                })
            },
            save() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let body = Object.assign({}, this.form)
                        body.discount = body.discount === '' ? null : body.discount
                        // 标签：数组转逗号字符串，最多4个
                        let tagArr = (body.tagArr || []).slice(0, 4).map(s => String(s).trim()).filter(Boolean)
                        body.tags = tagArr.length > 0 ? tagArr.join(',') : ''
                        delete body.tagArr
                        let url = this.form.id ? '/shop/admin/update' : '/shop/admin/save'
                        this.$axios.post(this.$httpUrl + url, body, {
                            params: {
                                operatorNo: this.user.no,
                                operatorName: this.user.name,
                                operatorRole: this.user.roleId
                            }
                        }).then(res => res.data).then(res => {
                            if (res.code == 200) {
                                this.$message({message: '操作成功！', type: 'success'});
                                this.centerDialogVisible = false
                                this.loadPost()
                            } else {
                                this.$message({message: res.msg || '操作失败！', type: 'error'});
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            resetParam() {
                this.keyword = ''
                this.categoryFilter = ''
            },
            handleSizeChange(val) {
                this.pageNum = 1
                this.pageSize = val
                this.loadPost()
            },
            handleCurrentChange(val) {
                this.pageNum = val
                this.loadPost()
            },
            loadPost() {
                this.$axios.post(this.$httpUrl + '/shop/admin/listPage', {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    param: {keyword: this.keyword, category: this.categoryFilter}
                }).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.tableData = res.data
                        this.total = res.total
                        this.loadTagOptions()
                    } else {
                        this.$message.error('获取数据失败')
                    }
                })
            }
        },
        beforeMount() {
            this.loadCategory()
            this.loadPost()
        }
    }
</script>

<style scoped>

</style>
